module.exports = __webpack_public_path__ + "static/img/h-banner_02.c9cdad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h-banner_02.png
// module id = 15
// module chunks = 1